import { Box, Icon } from '@factorialco/deprecated-design-system'

export const DragAndDropIcon = ({ hover = false }) => (
  <Box
    justifyContent="center"
    style={{
      visibility: hover ? 'visible' : 'hidden',
    }}
  >
    <Icon.Medium icon="drag-and-drop" color="grey800" />
  </Box>
)
